export { default } from './CamHighlightsPill';
